import { render, staticRenderFns } from "./CommomVideo.vue?vue&type=template&id=6a7830fc&scoped=true&"
import script from "./CommomVideo.vue?vue&type=script&lang=js&"
export * from "./CommomVideo.vue?vue&type=script&lang=js&"
import style0 from "./CommomVideo.vue?vue&type=style&index=0&id=6a7830fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7830fc",
  null
  
)

export default component.exports